<!-- <div class="preloader" [hidden]="load">
    <div class="loading">
        <img src="../../../assets/images/loader/loader.svg" alt="">
    </div>
</div> -->
<app-loading [hidden]="load"></app-loading>

<ngx-slick-carousel class="slider" #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let item of arraySlider" class="slide">
        <div class="slide-item align-v-h bg-overlay" style="
            background-image: url(https://api2.wcrg.org:444/images/post/{{item.postImage}});
            background-size: cover;
            background-position: center center;
            ">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                        <div class="slide-item__content">

                            <h2 class="slide-item__title">{{item.postTitle}}</h2>
                            <p class="slide-item__desc">
                                {{item.postSubTitle}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ngx-slick-carousel>
